import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Text from "components/Text";
import styles from "../../OfficePolicyManagement.module.scss";
import CommentSendIcon from "assets/images/send_comment_icon.svg";
import { formatLocalDateTime } from "utils";
import { useSelector } from "react-redux";
import Empty from "components/Empty";
import InfiniteScroll from "react-infinite-scroll-component";

export default function RightSection({
  assignmentId,
  addComments,
  setPageNumber,
  comments,
  totalItems,
}) {
  const { t } = useTranslation();
  const profile = useSelector((state) => state.userProfile?.profile);
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    if (e.target.value.length < 256) setError("");
    setComment(e.target.value);
  };

  const handleSubmit = () => {
    if (comment && comment.trim().length > 0 && comment.length < 256) {
      addComments(assignmentId, {
        comment: comment.trim(),
        text: comment.trim(),
      });
      setComment("");
      setError("");
    } else {
      setError(t("officePolicyManagement.commentError"));
    }
  };

  const handleCommentOwner = (user) => {
    if (user?.id === profile?.id) return "You";
    return `${user?.firstName ?? ""} ${user?.lastName ?? ""}`.trim() || "—";
  };

  const commentList = Array.isArray(comments) ? comments : [];
  const total = totalItems ?? 0;

  return (
    <div className={styles.staff_right_section}>
      <div className={styles.comment_container}>
        <div className={styles.comment_topbar}>
          <Text size="16px" weight="600" color="#2D3245">
            {t("officePolicyManagement.comments")} ({commentList.length})
          </Text>
        </div>
        <div className={styles.comment_body}>
          {commentList.length === 0 ? (
            <div className={styles.not_found}>
              <Empty Message={t("officePolicyManagement.commentNotFound")} />
            </div>
          ) : (
            <InfiniteScroll
              className="task_assignee w-100"
              dataLength={commentList.length}
              hasMore={commentList.length < total}
              next={() => setPageNumber((v) => v + 1)}
            >
              {commentList.map((c) => (
                <div
                  key={c.id}
                  className={`${styles.comment_text} ${
                    c?.user?.id === profile?.id ? styles.my_comment : ""
                  } mt-1`}
                >
                  <p className={styles.patient_name}>
                    {handleCommentOwner(c?.user)}
                  </p>
                  <div className={styles.date_time_wrapper}>
                    <p className={`${styles.date_time} m-0`}>
                      {formatLocalDateTime(c?.createdAt)}
                    </p>
                  </div>
                  <p className={styles.msg}>{c?.text ?? c?.comment ?? ""}</p>
                </div>
              ))}
            </InfiniteScroll>
          )}
        </div>
        <div className={styles.comment_footer}>
          <input
            type="text"
            placeholder={t(
              "officePolicyManagement.yourComment",
              "Your comment",
            )}
            value={comment}
            onChange={handleChange}
          />
          <img
            src={CommentSendIcon}
            alt="Send"
            onClick={handleSubmit}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") handleSubmit();
            }}
          />
        </div>
        {error && <span className="error-msg">{error}</span>}
      </div>
    </div>
  );
}
